import React from 'react'
import { Link } from 'react-router-dom'

const Speaker = () => {
  return (
    <section className="speakers-section">
    <div className="anim-icons full-width">
      <span className="icon icon-dotted-circle" />
    </div>
    <div className="auto-container">
      <div className="sec-title text-center">
        <span className="sub-title">Our SPEAKERS</span>
        <h2>
          Speakers Who Are Exparts <br />
          in Their Fields
        </h2>
        <span className="divider" />
      </div>
      <div className="row">
        {/* Speaker block */}
        <div className="speaker-block col-lg-3 col-md-6 col-sm-12 wow fadeInUp">
          <div className="inner-box">
            <div className="image-box">
              <figure className="image">
                <Link to="speaker-detail.html">
                  <img src="/assets/images/resource/speaker-1.jpg" alt="" />
                </Link>
              </figure>
              <span className="plus-icon fa fa-plus" />
              <div className="social-links">
                <Link to="#">
                  <i className="fab fa-dribbble" />
                </Link>
                <Link to="#">
                  <i className="fab fa-facebook-f" />
                </Link>
                <Link to="#">
                  <i className="fab fa-twitter" />
                </Link>
                <Link to="#">
                  <i className="fab fa-pinterest-p" />
                </Link>
              </div>
            </div>
            <div className="info-box">
              <h4 className="name">
                <Link to="speaker-detail.html">Patrick Spencer</Link>
              </h4>
              <span className="designation">S&amp;P Analyzer</span>
            </div>
          </div>
        </div>
        {/* Speaker block */}
        <div
          className="speaker-block col-lg-3 col-md-6 col-sm-12 wow fadeInUp"
          data-wow-delay="300ms"
        >
          <div className="inner-box">
            <div className="image-box">
              <figure className="image">
                <Link to="speaker-detail.html">
                  <img src="/assets/images/resource/speaker-2.jpg" alt="" />
                </Link>
              </figure>
              <span className="plus-icon fa fa-plus" />
              <div className="social-links">
                <Link to="#">
                  <i className="fab fa-dribbble" />
                </Link>
                <Link to="#">
                  <i className="fab fa-facebook-f" />
                </Link>
                <Link to="#">
                  <i className="fab fa-twitter" />
                </Link>
                <Link to="#">
                  <i className="fab fa-pinterest-p" />
                </Link>
              </div>
            </div>
            <div className="info-box">
              <h4 className="name">
                <Link to="speaker-detail.html">Matthew White</Link>
              </h4>
              <span className="designation">Facebook's Co-Founder</span>
            </div>
          </div>
        </div>
        {/* Speaker block */}
        <div
          className="speaker-block col-lg-3 col-md-6 col-sm-12 wow fadeInUp"
          data-wow-delay="600ms"
        >
          <div className="inner-box">
            <div className="image-box">
              <figure className="image">
                <Link to="speaker-detail.html">
                  <img src="/assets/images/resource/speaker-3.jpg" alt="" />
                </Link>
              </figure>
              <span className="plus-icon fa fa-plus" />
              <div className="social-links">
                <Link to="#">
                  <i className="fab fa-dribbble" />
                </Link>
                <Link to="#">
                  <i className="fab fa-facebook-f" />
                </Link>
                <Link to="#">
                  <i className="fab fa-twitter" />
                </Link>
                <Link to="#">
                  <i className="fab fa-pinterest-p" />
                </Link>
              </div>
            </div>
            <div className="info-box">
              <h4 className="name">
                <Link to="speaker-detail.html">Michael Dover</Link>
              </h4>
              <span className="designation">Starbuck's CEO</span>
            </div>
          </div>
        </div>
        {/* Speaker block */}
        <div
          className="speaker-block col-lg-3 col-md-6 col-sm-12 wow fadeInUp"
          data-wow-delay="900ms"
        >
          <div className="inner-box">
            <div className="image-box">
              <figure className="image">
                <Link to="speaker-detail.html">
                  <img src="/assets/images/resource/speaker-4.jpg" alt="" />
                </Link>
              </figure>
              <span className="plus-icon fa fa-plus" />
              <div className="social-links">
                <Link to="#">
                  <i className="fab fa-dribbble" />
                </Link>
                <Link to="#">
                  <i className="fab fa-facebook-f" />
                </Link>
                <Link to="#">
                  <i className="fab fa-twitter" />
                </Link>
                <Link to="#">
                  <i className="fab fa-pinterest-p" />
                </Link>
              </div>
            </div>
            <div className="info-box">
              <h4 className="name">
                <Link to="speaker-detail.html">Angelina Holy</Link>
              </h4>
              <span className="designation">Maxii's Manager</span>
            </div>
          </div>
        </div>
        {/* Speaker block */}
        <div className="speaker-block col-lg-3 col-md-6 col-sm-12 wow fadeInUp">
          <div className="inner-box">
            <div className="image-box">
              <figure className="image">
                <Link to="speaker-detail.html">
                  <img src="/assets/images/resource/speaker-5.jpg" alt="" />
                </Link>
              </figure>
              <span className="plus-icon fa fa-plus" />
              <div className="social-links">
                <Link to="#">
                  <i className="fab fa-dribbble" />
                </Link>
                <Link to="#">
                  <i className="fab fa-facebook-f" />
                </Link>
                <Link to="#">
                  <i className="fab fa-twitter" />
                </Link>
                <Link to="#">
                  <i className="fab fa-pinterest-p" />
                </Link>
              </div>
            </div>
            <div className="info-box">
              <h4 className="name">
                <Link to="speaker-detail.html">Janet Jones</Link>
              </h4>
              <span className="designation">Newyork Post's GM</span>
            </div>
          </div>
        </div>
        {/* Speaker block */}
        <div
          className="speaker-block col-lg-3 col-md-6 col-sm-12 wow fadeInUp"
          data-wow-delay="300ms"
        >
          <div className="inner-box">
            <div className="image-box">
              <figure className="image">
                <Link to="speaker-detail.html">
                  <img src="/assets/images/resource/speaker-6.jpg" alt="" />
                </Link>
              </figure>
              <span className="plus-icon fa fa-plus" />
              <div className="social-links">
                <Link to="#">
                  <i className="fab fa-dribbble" />
                </Link>
                <Link to="#">
                  <i className="fab fa-facebook-f" />
                </Link>
                <Link to="#">
                  <i className="fab fa-twitter" />
                </Link>
                <Link to="#">
                  <i className="fab fa-pinterest-p" />
                </Link>
              </div>
            </div>
            <div className="info-box">
              <h4 className="name">
                <Link to="speaker-detail.html">Michael Dover</Link>
              </h4>
              <span className="designation"> Starbuck's CEO</span>
            </div>
          </div>
        </div>
        {/* Speaker block */}
        <div
          className="speaker-block col-lg-3 col-md-6 col-sm-12 wow fadeInUp"
          data-wow-delay="600ms"
        >
          <div className="inner-box">
            <div className="image-box">
              <figure className="image">
                <Link to="speaker-detail.html">
                  <img src="/assets/images/resource/speaker-7.jpg" alt="" />
                </Link>
              </figure>
              <span className="plus-icon fa fa-plus" />
              <div className="social-links">
                <Link to="#">
                  <i className="fab fa-dribbble" />
                </Link>
                <Link to="#">
                  <i className="fab fa-facebook-f" />
                </Link>
                <Link to="#">
                  <i className="fab fa-twitter" />
                </Link>
                <Link to="#">
                  <i className="fab fa-pinterest-p" />
                </Link>
              </div>
            </div>
            <div className="info-box">
              <h4 className="name">
                <Link to="speaker-detail.html">Jonathan Elves</Link>
              </h4>
              <span className="designation"> Maxii's Manager</span>
            </div>
          </div>
        </div>
        {/* Speaker block */}
        <div
          className="speaker-block col-lg-3 col-md-6 col-sm-12 wow fadeInUp"
          data-wow-delay="900ms"
        >
          <div className="inner-box">
            <div className=" image-box">
              <figure className="image image-2">
                <Link to="speaker-detail.html">
                  <img src="/assets/images/resource/speaker-2.jpg" alt="" />
                </Link>
              </figure>
              <span className="plus-icon fa fa-plus" />
              <div className="social-links">
                <Link to="#">
                  <i className="fab fa-dribbble" />
                </Link>
                <Link to="#">
                  <i className="fab fa-facebook-f" />
                </Link>
                <Link to="#">
                  <i className="fab fa-twitter" />
                </Link>
                <Link to="#">
                  <i className="fab fa-pinterest-p" />
                </Link>
              </div>
            </div>
            <div className="info-box">
              <h4 className="name">
                <Link to="speaker-detail.html">Mike Michael</Link>
              </h4>
              <span className="designation">Softer Manager</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  
  )
}

export default Speaker